<template>
<div class="orderDetails-wrap">
    <div class="orderDetails">
        <div class="details-header">
            <h2>订单详情</h2>
        </div>
        <div class="details-content" v-if="JSON.stringify(orderInfo) !='{}'">
            <div class="goods-info">
                <div class="img-info">
                    <div class="img-wrap">
                        <img :src="orderInfo.photo" alt="">
                    </div>
                    <div class="text-info">
                        <span class="action">{{orderInfo.action_name}}</span>
                        <span>{{orderInfo.car_name}}</span>
                    </div>
                </div>
                <div class="price-info">
                    <div class="price add">
                        <span>活动意向金</span>
                        <span>{{orderInfo.order_price}} 元</span>
                    </div>
                    <div class="price need">
                        <span>{{orderInfo.stateN}}</span>
                        <span>{{orderInfo.order_price}} 元</span>
                    </div>
                </div>
            </div>
            <div class="order-info">
                <div class="orderItm title">订单信息</div>
                <div class="orderItm">
                    <span class="left">订单编号</span>
                    <span>{{orderInfo.order_num}}</span>
                </div>
                <div class="orderItm">
                    <span class="left">下单时间</span>
                    <span>{{orderInfo.time}}</span>
                </div>
                <div class="orderItm" v-if="orderInfo.state == 1">
                    <span class="left">支付时间</span>
                    <span>{{orderInfo.update_time}}</span>
                </div>
                <div class="orderItm">
                    <span class="left">活动时间</span>
                    <span>{{orderInfo.starttime}} - {{orderInfo.endtime}}</span>
                </div>
            </div>
            <div class="user-info">
                <div class="name userItem">
                    <span class="left">下单姓名</span>
                    <span>{{orderInfo.uname}}</span>
                </div>
                <div class="tell userItem">
                    <span class="left">手机号</span>
                    <span>{{orderInfo.tell}}</span>
                </div>
            </div>
        </div>
        <div v-else class="wangluo">
            <div class="wangluo-img">
                <img src="../../static/image/wangluo.jpg" alt="">
            </div>
            <div class="refreash">请刷新</div>
        </div>
        <div class="details-footer">
            <el-button type="primary" @click="$router.push('/gocat')">回购车惠页面</el-button>
            <el-button type='danger' @click="changeRoute()">{{buttenText}}</el-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    wexinPay
} from "@/WxPay/WxPay"
export default {
    name: 'OrderDetails',
    data() {
        return {
            orderNum: '',
            orderInfo: {},
            buttenText: ''
        }
    },
    created() {
        this.orderNum = this.$route.params.id;
        this.getOrderInfo()

    },
    methods: {
        async getOrderInfo() {
            const result = await this.$http.signUp.getOrderInfoByID({
                ordernum: this.orderNum
            })
            if (result.code === 200) {
                let state = {
                    0: '待支付',
                    1: '支付成功',
                    3: '退款成功'
                }
                let obj = {
                    0: '去支付',
                    1: '回首页',
                    2: '回首页'
                }
                this.orderInfo = result.data;
                this.orderInfo.stateN = state[result.data.state];
                this.buttenText = obj[result.data.state];
            } else {
                this.$message({
                    message: '暂无数据。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },
        changeRoute() {
            if (this.orderInfo.state === '0') {

                this.$http.signUp.doPay({
                    // url: document.domain
                    url: 'https://jingcaicheshi.com',
                    ordernum: this.orderNum
                }).then(res => {
                    wexinPay(res.data).then(res => {
                        this.buttenText = '查看订单'
                        window.location.href = `https://jingcaicheshi.com/#/myorder`;
                    }).catch(err => {
                        this.$message({
                            message: '支付失败!',
                            type: 'error',
                            center: true,
                            offset: 130
                        })
                    })
                })
            } else if (this.orderInfo.state === '1') {
                this.buttenText = '回首页'
                this.$router.push('/home')
            }
        }
    }

}
</script>

<style lang="less">
.orderDetails-wrap {
    height: 100vh;
    position: relative;

    .orderDetails {

        height: 100vh;
        width: 100vw;
        padding: 20px;

        .details-header {
            height: 80px;
            font-size: 34px;
            text-align: center;
            border-bottom: 1px solid #eee;
            margin-bottom: 30px;
        }

        .details-content {

            .goods-info {
                background: #efefff;
                margin-bottom: 20px;

                .img-info {
                    display: flex;
                    justify-content: space-between;

                    .img-wrap {
                        width: 40%;

                        img {
                            width: 100%;
                        }
                    }

                    .text-info {
                        width: 55%;
                        display: flex;
                        flex-direction: column;

                        .action {
                            font-size: 30px;
                            margin-bottom: 20px;
                            margin-top: 30px;
                        }
                    }

                }

                .price-info {

                    .price {
                        height: 50px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .add {
                        color: #333;
                    }

                    .need {
                        color: #f56c6c;
                        font-size: 36px;
                    }
                }
            }

            .order-info {
                background: #efefff;
                padding: 0 20px;
                margin-bottom: 20px;

                .orderItm {
                    height: 60px;
                    line-height: 60px;

                    .left {
                        margin-right: 20px;
                    }
                }

                .title {
                    font-size: 38px;
                }
            }

            .user-info {
                background: #efefff;

                .userItem {
                    height: 80px;
                    line-height: 80px;
                    font-size: 38px;

                    .left {
                        margin: 20px;
                    }
                }
            }
        }
        .wangluo{
           .wangluo-img{
               width: 60vw;
               height: 800px;
               margin: 0 auto;
               img{
                   width: 100%;
                   height: 100%;
               }
           }
           .refreash{
               width: 260px;
               height: 60px;
               text-align: center;
               line-height: 60px;
               font-size: 40px;
               border: 1px solid #f06e6e;
               border-radius: 30px;
               margin: 0 auto;
           }  

        }
        .details-footer {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 100px;
            display: flex;
            justify-content: space-around;
            width: 100%;

            .el-button {
                height: 80px;
                width: 300px;
                font-size: 40px;
            }

        }
    }
}
</style>
